export const NAV_BAR_HEIGHT = 72
